

module.exports = __webpack_require__.stylable.create(
    "o7",
    {"classes":{"root":"s305","brand":"s311","brandContainer":"s306","slogan":"s307","menuToggle":"s308","devToggleButton":"s309","headerNav":"s310"},"vars":{"color-primary-light":"--o0-color-primary-light","color-primary-dark":"--o0-color-primary-dark","color-secondary-dark":"--o0-color-secondary-dark","border-2":"--o0-border-2","border-3":"--o0-border-3"},"stVars":{},"keyframes":{}},
    "",
    3,
    3,
    null
);
